import {
    inject,
    ObjectGraph,
} from '@jet/environment/dependencies/object-graph';
import type { IntentController } from '@jet/environment/dispatching';
import type { PageChangeInstruction } from '../../models/invalidation/change-instruction/PageChangeInstruction';
import type { RefreshPageIntent } from './RefreshPageIntent';
import { ObjectGraphType } from '../../dependencies';
import { Logger } from '../../dependencies/logger';

export const RefreshPageIntentController: IntentController<RefreshPageIntent> =
    {
        $intentKind: 'RefreshPageIntent',

        async perform(
            intent: RefreshPageIntent,
            objectGraph: ObjectGraph,
        ): Promise<PageChangeInstruction> {
            Logger.log(
                objectGraph,
                `Refreshing Page Kind '${intent.intent.$kind}' for reason "${intent.reason}".`,
            );

            const intentDispatcher = inject(
                ObjectGraphType.intentDispatcher,
                objectGraph,
            );
            const newPage = await intentDispatcher.dispatch(
                { ...intent.intent, metadata: intent.metadata },
                objectGraph,
            );
            return {
                instruction: {
                    instruction: 'replacePage',
                    newPage,
                },
            };
        },
    };
